import { z } from 'zod'
import { type PrintPointRedirect } from '../../models/PrintPointRedirect'
import { mapDTOToPeripheral, PeripheralDTO } from './PeripheralDTO'

export const PrintPointRedirectDTO = z.object({
  from_id: z.number().nullish(),
  from: PeripheralDTO.nullish(),
  to_id: z.number().nullish(),
  to: PeripheralDTO.nullish()
})

export type PrintPointRedirectDTO = z.infer<typeof PrintPointRedirectDTO>

export function mapDTOToPrintPointRedirect (dto: PrintPointRedirectDTO): PrintPointRedirect {
  return {
    id: `${dto.from?.id}-${dto.to?.id}`,
    from: dto.from ? mapDTOToPeripheral(dto.from) : undefined,
    to: dto.to ? mapDTOToPeripheral(dto.to) : undefined
  }
}

export function mapPrintPointRedirectToDTO (model: PrintPointRedirect): PrintPointRedirectDTO {
  return {
    from_id: model.from?.id,
    to_id: model.to?.id
  }
}
